import store from '@/store';
import { userGetinfoApi } from '@/api/common';
import { USER_USERINFO_UPDATE } from '@/store/mutationTypes';

export const userInfoPromise = async () => {
  return userGetinfoApi({}, { to: { meta: { auth: 0 } } });
};

export const userInfoCommitPromise = async () => {
  await new Promise((resolve) => setTimeout(resolve, 0));
  const resData = await userInfoPromise();
  const userInfo = resData.data || {};
  localStorage.setItem('userId', JSON.stringify(userInfo.userId || ''));
  store.commit(USER_USERINFO_UPDATE, userInfo);
  return userInfo;
};

export const userInfoCommitComposable = userInfoCommitPromise();
